export default __webpack_public_path__ + "static/media/P1.c5c052f2.png";